
/**
 * 
 * @hidden
 */
export enum CacheModes {

    /**
     * 
     */
    None = 1,

    /**
     * 
     */
    Request = 2,

    /**
     * 
     */
    Session = 3,

    /**
     * 
     */
    Application = 4,

    /**
     * 
     */
    Temporary = 5,
}
